/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseBcReporting } from '../../models/api-response-bc-reporting';
import { PagedRequestReportingBroadcastSearch } from '../../models/paged-request-reporting-broadcast-search';

export interface ReportingBroadcast$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestReportingBroadcastSearch
}

export function reportingBroadcast(http: HttpClient, rootUrl: string, params: ReportingBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBcReporting>> {
  const rb = new RequestBuilder(rootUrl, reportingBroadcast.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseBcReporting>;
    })
  );
}

reportingBroadcast.PATH = '/v1/api/ui/broadcast/reporting';
